<template>
  <div
    v-if="linkTitle"
    v-click-outside="close"
    class="login-links"
    @click="toggle"
    @mouseenter="isMobile || isTouch ? null : open()"
    @mouseleave="isMobile || isTouch ? null : close()"
  >
    <a class="login-links__trigger" tabindex="0" @keydown="onKeydown">
      <dotcom-icon
        :key="showLinkDropdown"
        class="login-links__icon"
        name="user"
      />
      <span class="login-links__label">
        {{ linkTitle }}
      </span>
    </a>

    <popover class="login-links__links_dropdown" :is-visible="showLinkDropdown">
      <ul>
        <li
          v-for="(link, index) in links"
          :key="index"
          data-track-as="sanitaslink"
        >
          <a class="login-links__link" :href="link.href">
            <span>{{ link.title }}</span>
            <dotcom-icon name="arrow-right-to-bracket" art="light" />
          </a>
        </li>
      </ul>
    </popover>
  </div>
</template>

<script>
import clickOutside from '@/directives/click-outside'

import Popover from '../common/Popover'

export default {
  name: 'LoginLinks',

  directives: {
    clickOutside,
  },

  components: {
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
    Popover,
  },
  props: {
    linkTitle: {
      type: String,
      default: '',
    },

    links: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      showLinkDropdown: false,
    }
  },

  computed: {
    isMobile() {
      return !this.$mq['lg!']
    },
    isTouch() {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0
    },
  },

  methods: {
    toggle() {
      this.showLinkDropdown = !this.showLinkDropdown
    },
    close() {
      this.showLinkDropdown = false
    },
    open() {
      this.showLinkDropdown = true
    },
    onKeydown(e) {
      if (e.keyCode === 13) {
        this.toggle()
      }
    },
  },
}
</script>

<style lang="postcss" scoped>
.login-links {
  position: relative; /* ensure that the popover is properly shown */
  display: flex;
  justify-content: center;
  padding: var(--spacing-2);
  margin: calc(var(--spacing-2) * -1);
}

.login-links__trigger {
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  color: var(--c-primary-neutral-1);

  &:hover {
    color: var(--c-primary-color-2);
  }
}

.login-links__trigger,
.login-links__link {
  &:hover {
    border-bottom: none;
  }
}

.login-links__link {
  display: flex;
  flex-direction: row;
  gap: var(--spacing-2);
  align-items: center;
  justify-content: space-between;
  white-space: nowrap;
  line-height: 16px;
}

.login-links__icon {
  font-size: 16px;
  pointer-events: none;
}

.login-links__label {
  display: none;
}

@media (--lg) {
  .login-links__links_dropdown {
    justify-content: flex-start;
    left: calc(-1 * var(--spacing-2));
  }
}

@media (--xl) {
  .login-links__label {
    display: block;
  }
}
</style>
